import { render, staticRenderFns } from "./ProductSyncCounter.vue?vue&type=template&id=059a0593&scoped=true&"
import script from "./ProductSyncCounter.vue?vue&type=script&lang=js&"
export * from "./ProductSyncCounter.vue?vue&type=script&lang=js&"
import style0 from "./ProductSyncCounter.vue?vue&type=style&index=0&id=059a0593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a0593",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
